import { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { motion } from "framer-motion";
import { toast } from "react-toastify";



const News = () => {

const [news, setNews] = useState([]);

const servidor = "https://analytics.centenario.com.pe";
//const servidor = "http://localhost:3000";

  // Obtener datos desde API
  const fetchData = async () => {
    try {
      const [listNews] = await Promise.all([
        axios.get(`${servidor}/api/listnews`),
      ]);

      setNews(listNews.data);

    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };


    useEffect(() => {

        if(news.length === 0)
        {
            fetchData();
        }

    }, [news]);


    return (

        <>
        {/* Listado fijo de noticias */}
            <div className="mt-4">
            <h2 className="h5 fw-semibold mb-3">📰 Anuncios</h2>

            <div className="row g-3">
              {news
              .filter((n) => {
                // 🔹 Hora actual en Lima (PE)
                const now = new Date(
                  new Date().toLocaleString("en-US", { timeZone: "America/Lima" })
                );

                const dateIni = new Date(n.DateIni);
                const dateFin = new Date(n.DateFin);

                // ✅ Mostrar solo noticias vigentes n.IsEnabled === 1 && now >= dateIni && now <= dateFin
                return n.IsEnabled == 1 && now >= dateIni && now <= dateFin;
              })
              .map((n) => {
                // Determinar estilo según tipo
                let cardClass = "border-secondary";
                let badgeClass = "bg-secondary";
                let badgeText = "Info";

                if (n.Type === "error") {
                  cardClass = "border-danger";
                  badgeClass = "bg-danger";
                  badgeText = "Error";
                } else if (n.Type === "warning" || n.Type === "important") {
                  cardClass = "border-warning";
                  badgeClass = "bg-warning text-dark";
                  badgeText = "Importante";
                } else if (n.Type === "success") {
                  cardClass = "border-success";
                  badgeClass = "bg-success";
                  badgeText = "Informativo";
                }

                return (
                  <div className="col-12 col-sm-6 col-lg-4" key={n.Id}>
                    <div className={`card h-100 shadow-sm border-2 ${cardClass}`} style={{maxWidth:'40vh'}}>
                      <div className="card-body d-flex flex-column">
                                    {/* Etiqueta de tipo */}
                                    <span className={`badge ${badgeClass} mb-2 align-self-start`}>
                                      {badgeText}
                                    </span>

                                    {/* Título */}
                                    <h6 className="card-title fw-bold">{n.Title}</h6>

                                    {/* Mensaje */}
                                    <p className="card-text text-muted flex-grow-1" style={{fontSize:'8pt',textAlign:'justify'}}>{n.Message}</p>

                                    {/* Fecha */}
                                    <small className="text-secondary" style={{fontSize:'8pt'}}>
                                      {new Date(n.DateIni).toLocaleDateString("es-PE", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                      })}{" "}
                                      {new Date(n.DateIni).toLocaleTimeString("es-PE", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
            </div>
        </>
    );

}

export default News;